// extracted by mini-css-extract-plugin
export default {"hiddenTextbox":"DyXGs8GmDihIWhGUTnLO","addNoteButton":"KATjkHiGoWdiZ1c20t6x","textbox":"ZDj8T0e6wd0rtosn41AK"};